module.exports = __webpack_public_path__ + "c7567cb201d99e8e5ca7aa2c886fff83.png";